import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

import { useDataGridSizingLocalStorage } from '@/components/DataGrid.utils';
import { GridPaginationModel } from '@/hooks/useDataGridState';
import { RuleSchema } from '@/types/schema';

interface Headers {
  'x-pagination-total': number;
}

type RowData = RuleSchema[] & {
  headers?: Headers | undefined;
};

interface UseEvaluatorsTableProps {
  rows?: RowData;
  paginationModel: GridPaginationModel;
  onPaginationChange: React.Dispatch<React.SetStateAction<GridPaginationModel>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: ColumnDef<RuleSchema, any>[];
  setDeleteOpen?: (id: string, resource: 'rules' | 'formulas') => void;
}

export const useEvaluatorsTable = ({
  rows,
  paginationModel,
  onPaginationChange,
  columns,
  setDeleteOpen,
}: UseEvaluatorsTableProps) => {
  'use no memo';
  const EMPTY_TABLE = [];

  const [columnSizing, setColumnSizing] =
    useDataGridSizingLocalStorage('evaluators');

  return useReactTable({
    columns: columns,
    data: rows ?? EMPTY_TABLE,
    state: {
      pagination: paginationModel,
      columnSizing,
    },
    meta: {
      actions: {
        handleDelete: setDeleteOpen,
      },
    },
    onPaginationChange,
    onColumnSizingChange: setColumnSizing,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    manualExpanding: true,
    manualPagination: true,
    manualFiltering: true,
    manualSorting: true,
    columnResizeMode: 'onChange',
    pageCount: Math.ceil(
      +(rows?.headers?.['x-pagination-total'] || 0) / paginationModel.pageSize
    ),
  });
};
